import React, { useState, useEffect, useRef } from 'react';
import { ModalArea } from '../../common/ModalButtonArea';
import { BigButton, InfiniteScroll, Loader } from '../../common';
import { Dropdown } from 'react-bootstrap';
import { useRooms } from '../../hooks/useRooms';

function CreateVideoPopUp({ show, setShow, submitRenderJob, defaultRoom }) {
  const [room, setRoom] = useState();
  const [showList, setShowList] = useState(false);
  const [clickLoading, setClickLoading] = useState();
  const searchRef = useRef();

  const { list, fetchMoreData, hasMore, loading, onSearchChange } = useRooms({
    filterByKey: 'room_type',
  });

  useEffect(() => {
    setRoom(defaultRoom);
    window.addEventListener('click', (e) => setShowList(false));

    return () => window.removeEventListener('click', () => setShowList(false));
  }, []);

  const handleYesClick = async () => {
    setClickLoading(true);
    await submitRenderJob(room?.id ? room?.id : defaultRoom?.id);
    setClickLoading(false);
  };

  return (
    <ModalArea
      showModal={show}
      setShowModal={setShow}
      title="Please select the room in which you want to render preview videos.(Default room is already selected)"
      centered={true}
      body={
        <div>
          <div
            id="__IMAGINE_AI_VIDEO_DROP_DOWN__"
            className="w-100 py-3 position-relative"
            style={{ height: showList ? '300px' : 'auto', overflow: 'overlay' }}>
            <InfiniteScroll
              dataLength={list.length}
              next={fetchMoreData}
              hasMore={hasMore}
              scrollableTarget="__IMAGINE_AI_VIDEO_DROP_DOWN__"
              style={{ height: showList ? '300px' : 'auto' }}
              loading={showList ? loading : ""}>
              <div className="d-flex gap-3 align-items-center">
                <span style={{ width: '15%' }}>
                  <b>Room :</b>
                </span>
                <input
                  ref={searchRef}
                  placeholder={room ? room?.name : 'Select room'}
                  className="p-2 ai-video-custom-input  w-100"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowList(true);
                  }}
                  onKeyDown={(e) => {
                    window.$restrictFilter = null
                    if (e.keyCode === 13) onSearchChange(e.target.value);
                  }}
                />
              </div>
              <Dropdown.Menu className="w-100" show={showList}>
                {list?.length ? list.map((item) => (
                  <Dropdown.Item
                    key={item.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      searchRef.current.value = '';
                      setRoom(item);
                      setShowList(false);
                    }}
                    style={{ fontSize: '0.85rem' }}>
                    {item.name}
                  </Dropdown.Item>
                )): null}
              </Dropdown.Menu>
            </InfiniteScroll>
          </div>
          <div className="d-flex gap-3 w-100 justify-content-center">
            <BigButton
              className="w-25"
              onClick={() => setShow(false)}
              style={{ background: '#D7D7D7' }}>
              <span className="px-3">Cancel</span>
            </BigButton>
            <BigButton className="w-25" isLoading={clickLoading} onClick={handleYesClick}>
              <span className="text-white px-3">Submit</span>
            </BigButton>
          </div>
        </div>
      }
    />
  );
}

export default CreateVideoPopUp;
